import React from 'react';
import { Link } from 'react-router-dom';
import useTripClaimsSummary from '../../Hooks/useTripClaimsSummary';
import { TRIP_CLAIMS_PATH, tripClaimsMessage } from '../../Utils/tripClaims';

/**
 * "7 trip claims waiting for review" above the Orders table.
 *
 * Everything else about trip claims is per-order — a row badge, a banner
 * inside one booking's details — so a claim on a booking nobody happens to
 * open is only visible on the header count, which is easy to walk past.
 *
 * Deliberately quiet: one thin strip, no colour block, no icon shouting.
 * This is a standing condition, not an error, and it is above a table people
 * use all day — if it pushed the table down every morning they would stop
 * seeing it, which is the opposite of the point. Nothing at all is rendered
 * at zero.
 *
 * Reads the count the header already polls (`useTripClaimsSummary`), so this
 * costs no request of its own and shows the same number the menu does.
 */
function TripClaimsStandingNotice({ isAuthed = true }) {
  const counts = useTripClaimsSummary(isAuthed);

  if (!counts.total) return null;

  return (
    <div className="small text-muted mb-2" data-testid="trip-claims-standing-notice">
      <i className="fa fa-receipt me-1 text-warning" />
      <span>{tripClaimsMessage(counts)}</span>
      {' · '}
      <Link to={TRIP_CLAIMS_PATH} className="fw-semibold">Review them</Link>
    </div>
  );
}

export default TripClaimsStandingNotice;
